module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "notifiCate"
  }, [_vm._v("Notifications")]), _vm._v(" "), _vm._l((_vm.notifications), function(n) {
    return _c('div', {
      staticClass: "tile tile-notification",
      class: {
        hidden: n.hidden
      }
    }, [_c('div', {
      staticClass: "tile-icon"
    }, [_c('router-link', {
      attrs: {
        "to": '/users/' + n.aboutUser._id
      }
    }, [_c('avatar', {
      key: n.aboutUser._id,
      attrs: {
        "user": n.aboutUser
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "tile-content"
    }, [_c('div', {
      staticClass: "tile-title"
    }, [_vm._v("\n        " + _vm._s(n.aboutUser.profile.corporate ?
      n.aboutUser.profile.business :
      n.aboutUser.profile.firstname + ' ' + n.aboutUser.profile.lastname) + "\n        "), _c('span', {
      staticStyle: {
        "font-size": "0.8em",
        "float": "right"
      }
    }, [_vm._v(_vm._s(new Date(n.date).toLocaleDateString('en-GB')))])]), _vm._v(" "), _c('div', {
      staticClass: "tile-subtitle text-gray"
    }, [_vm._v(_vm._s(n.content))])]), _vm._v(" "), _c('div', {
      staticClass: "tile-action"
    }, [_c('button', {
      staticClass: "btn btn-clear float-right",
      on: {
        "click": function($event) {
          return _vm.del(n)
        }
      }
    })])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57e87700"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/adminHome/notifications.vue
// module id = 500
// module chunks = 1